import { updateState } from '@/store/extensions/update';
import { fetchState } from '@/store/extensions/fetch';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ...updateState,
  ...fetchState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/app/index.js